import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {ToastService} from "../../../services/Toast.service";
import {Session} from "../../../services/Session";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";

declare const _: any;

@Component({
  selector: 'app-strategy-preferred-vendors',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqFroalaViewComponent],
  templateUrl: './strategy-preferred-vendors.component.html',
  styleUrl: './strategy-preferred-vendors.component.scss'
})
export class StrategyPreferredVendorsComponent implements OnInit, OnDestroy {
  user: any;
  org: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @Input() strategyVendors: any;
  @Input() strategy: any;
  currentSelectedVendor: any;
  documents: Array<any> = [];
  images: Array<any> = [];
  videos: Array<any> = [];
  currentSelectedImage: any;
  showPreview = false;

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    if (this.strategyVendors && this.strategyVendors.length > 0) {
      _.each(this.strategyVendors, (vendor) => {
        let obj = _.find(vendor.strategies, {strategyId: base.strategy.importedFrom});
        if (!obj){
          obj = _.find(vendor.strategies, {strategyId: base.strategy.id});
        }
        vendor['strategyInfo'] = (obj) ? obj : {};
      });
      this.currentSelectedVendor = this.strategyVendors[0];
      this.setLogoBackgroundStyle();
      this.setUpMedia();
    }
  }

  setLogoBackgroundStyle() {
    if (this.currentSelectedVendor && this.currentSelectedVendor.logo) {
      this.currentSelectedVendor.logoBg = {
        background: 'url("' + this.currentSelectedVendor.logo + '") center center no-repeat',
        'background-size': 'contain'
      };
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openOfferLink() {
    const link = this.currentSelectedVendor.strategyInfo.offer.link || '';
    if (link) {
      window.open(link);
    }
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  showImagePreview(file) {
    this.currentSelectedImage = file;
    this.showPreview = true;
  }

  downloadVideo(video) {
    window.open(video.link);
  }

  selectVendor(vendor) {
    this.currentSelectedVendor = vendor;
    this.setLogoBackgroundStyle();
    this.setUpMedia();
  }

  setUpMedia() {
    const data = _.cloneDeep(this.currentSelectedVendor.strategyInfo);
    this.documents = (data && data.files) ? JSON.parse(data.files): [];
    this.images = (data && data.images) ? JSON.parse(data.images): [];
    if (this.images.length > 0) {
      this.currentSelectedImage = this.images[0];
      this.showPreview = true;
    } else {
      this.currentSelectedImage = '';
      this.showPreview = false;
    }
    this.videos = (data && data.videos) ? JSON.parse(data.videos): [];
  }

}
